import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';

export const initialize = createAction(types.INITIALIZE);
export const cleanup = createAction(types.CLEANUP);
export const toggleJobSelection = createAction(types.JOB_SELECTION_TOGGLE);
export const setJobSelection = createAction(types.JOB_SELECTION_SET);
export const clearJobSelection = createAction(types.JOB_SELECTION_CLEAR);

export const getUsers = createApiAction(
  types.GET_USERS,
  () => api.getUsers(),
  { meta: { skipErrorPage: true } },
);
